
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Eine Rolle spielen dürften die enge Verflechtung mit dem angrenzenden Norditalien, wo die Pandemie besonders schlimm wütet, und die Fasnacht. Noch bis am 24. Februar 2020 feiern mehr als hunderttausend Menschen dicht gedrängt den Rabadan-Karneval in Bellinzona. Dann beendet die Tessiner Regierung den mehrtägigen Anlass abrupt. Einen Tag später vermeldet das Spital Moncucco den `}<a parentName="p" {...{
        "href": "https://www.tagesanzeiger.ch/wissen/coronaviruspatient-eins-liegt-im-spital-in-lugano/story/31145440"
      }}>{`ersten Corona-Patienten`}</a>{` der Schweiz.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;